import React from 'react';

import { Picker } from 'emoji-mart';
import { useTheme } from '@material-ui/core/styles';

import { call, classes } from 'utils';

import styles from './EmojiPicker.module.scss';
import 'emoji-mart/css/emoji-mart.css';

const EmojiPicker = ({ onSelect, ...props }) => {
  const theme = useTheme();

  return (
    <div className={classes(styles.emojiPicker, styles[theme.name || ''])}>
      <Picker
        native={true}
        style={{ width: '100%', ...props.style }}
        onSelect={e => {
          const codes = e.unified.split('-').map(it => `0x${it}`);
          call(onSelect, String.fromCodePoint(...codes));
        }}
        title="Pick your emoji…"
        emoji="point_up"
        i18n={{
          search: 'Search',
          notfound: 'No Emoji Found',
          categories: {
            search: 'Search Results',
            recent: 'Frequently Used',
            people: 'Smileys & People',
            nature: 'Animals & Nature',
            foods: 'Food & Drink',
            activity: 'Activity',
            places: 'Travel & Places',
            objects: 'Objects',
            symbols: 'Symbols',
            flags: 'Flags',
          },
        }}
        {...props}
      />
    </div>
  );
};

export default EmojiPicker;
